
export const userCallingModel = {
  uid: null,
  email: null,
  page_number: 0,
  page_size: 10,
  event_id: null,
  search_term: null,
  date_from: null,
  date_at: null,

  costruttore (userinfo, pageNumber, pageSize, totalPages, eventId, searchTerm, dateFrom, dateAt) {
    this.event_id = eventId
    this.search_term = searchTerm
    this.uid = userinfo.uid
    this.email = userinfo.email
    this.page_number = pageNumber - 1
    this.date_from = dateFrom
    this.date_at = dateAt

    if (this.page_number <= 0) {
      this.page_number = 0
    }

    if (totalPages != null && this.page_number >= totalPages) {
      this.page_number = totalPages
    }

    this.page_size = pageSize
  }

}
